import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "src/styles";
import styled from "styled-components";

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 500px;
  box-sizing: content-box;
  gap: 10px;
  margin-bottom: 0;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

export const StyledInput = styled.input`
  border-radius: 4px;
  border: 1px solid ${colors.grey.light12};
  height: 40px;
  padding: 7px 35px 7px 12px;
  font-size: 14px;
  width: 100%;

  &:focus {
    outline: none;
    border: 1px solid ${colors.kleenway.green};
    box-shadow: 0 0 0 3px rgba(129, 193, 125, 0.1);
  }
`;

export const Icon = styled(FontAwesomeIcon)`
  position: absolute;
  right: 12px;
  width: 16px;
  height: 16px;
  color: ${colors.grey.dark4};
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: ${colors.grey.dark};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;

  & button {
    padding: 8px 16px;
    font-size: 14px;
  }
`;
